<template>
    <div class="container">
        <div>
            <div class="col-12 pb-4">
                <div class="font-glacial-regular row d-box align-items-center text-center">
                    <b-form-input class="form-search font-45 search-padding" size="lg" v-model="text1" @input="searchDebounce" type="text" placeholder="  buscar">
                    </b-form-input>
                </div>
            </div>
            <div class="container pt-5" key="categorias">
                <div class="row justify-content-center pt-0 pt-xl-0 mb-0 pt-lg-4 mb-lg-4">
                    <div class="font-glacial-bold font-20 font-size-blog pr-xl-5 pr-md-4 d-block d-xl-block text-center clickable pr-4" 
                        @click="changeCategory(13)"
                        :class="{'text-categories-red' : category == 13}">
                        Ribeirão Preto
                    </div>
                    <div class="font-glacial-bold font-20 font-size-blog pr-xl-5 pr-md-4 d-block d-xl-block text-center clickable" 
                        @click="changeCategory(14)"
                        :class="{'text-categories-red' : category == 14}">
                        Piracicaba
                    </div>
                </div>

                <div class="row eventos btn-pointer justify-content-center pt-5 pt-sm-0" v-if="postsSliced.length > 0">
                    <blog-item type="materia" no-grid :item="d" :cat="showCategory(d.pure_taxonomies.categories)" :large="index == 0 || index == 3" v-for="(d, index) in postsSliced" :key="index"/>              
                </div>
                <div id="load-post"></div>
                <div class="col-12 text-categories-red text-center font-glacial-bold font-20" v-if="loading">
                    <rotate-square2 class="box-center"></rotate-square2>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {RotateSquare2} from 'vue-loading-spinner'

    export default {
        components: {
            RotateSquare2
        },

        props:{
            data: null
        },

        data(){
            return {
                posts: [],
                page: 0,
                loading: false,
                total: 0,
                indexData: 7,
                pageLength: 7,
                text1: '',
                category: null,
                newPage: true,
            }
        },

        created(){
            this.loadMore()
        },

        mounted() {
            window.addEventListener("scroll", this.scrollEvent)
        },

        beforeDestroy() {
            window.removeEventListener("scroll", this.scrollEvent)
        },

        computed:{
            postsSliced: {
                set(value) {
                    var arr = this.posts.concat(value)
                    this.posts = arr
                },

                get() {
                    if (!this.posts) {
                        return []
                    }

                    return this.posts
                }
            },
        },

        methods:{
            showCategory(category){
                var cat = category[0].name

                for(let i = 0; i < category.length; i++){
                    if(category[i].slug == 'eventos'){
                        for(let aux = 0; aux < category.length; aux++){
                            if(category[aux].slug == 'ribeirao-preto' || category[aux].slug == 'piracicaba'){
                                cat = category[aux].name
                            }
                        }
                    }
                }

                return cat
            },

            scrollEvent(e) {
                var el = document.getElementById('load-post')
                if (this.isInViewport(el)) {
                    this.loadMore()
                }
            },

            isInViewport(elem) {
                var bounding = elem.getBoundingClientRect();
                return (
                    bounding.top >= 0 &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            },

            searchDebounce: _.debounce(function() {
                this.page = 0
                this.newPage = true
                this.posts = []
                this.loadMore()
            }, 200),

            changeCategory(cat) {
                this.page = 0
                this.posts = []
                this.newPage = true
                this.category = cat

                this.loadMore()
            },

            async loadMore(){
                if (!this.newPage) {
                    return
                }

                if (this.loading) {
                    return
                }

                this.page++

                this.loading = true
                if (this.category > 0) {
                    var url = window.SETTINGS.API_BASE_PATH + `posts?_embed&per_page=${this.pageLength}&page=${this.page}&categories=5&categories=${this.category}`
                } else {
                    var url = window.SETTINGS.API_BASE_PATH + `posts?_embed&per_page=${this.pageLength}&page=${this.page}&categories=5`
                }

                if(this.text1 != ""){
                    url = url + "&search=" + this.text1
                }

                try {
                    var response = await axios.get(url)
                    
                    if (response.data.length < this.pageLength) {
                        this.newPage = false
                    }

                    this.total = response.headers["x-wp-total"]
                    this.postsSliced = response.data
                } catch (e) {
                    this.newPage = false
                    console.log(e)
                }

                this.loading = false
            }
        }
    }
</script>
<style scoped>
.eventos {
    min-height: 300px;
}

.box-center {
    margin: 20px auto;
}
.spinner:after {
    background: #FF0002 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/eventos.vue